<div class="new_comment flex items-center gap-2">
  <!-- @if (picturePath()) {
    <div class="user__image">
      <img [src]="picturePath()" alt="user-img" />
    </div>
  } -->

  <form
    [formGroup]="form"
    class="comment_field flex items-center gap-2 flex-1"
    novalidate
    (submit)="submit()"
  >
    <textarea
      [formControl]="form.controls.comment"
      placeholder="{{ 'Add a comment' | translate }}"
      class="flex-1"
      rows="3"
    ></textarea>

    @if (isShowErrors) {
      <span
        class="text-red-500 block"
        *ngIf="form.controls.comment?.errors?.['required']"
        translate="This field is required"
      ></span>

      <span
        class="text-red-500 block"
        *ngIf="form.controls.comment?.errors?.['maxlength']"
        >{{ "The maximum number of characters is" | translate }}
        {{ form.controls.comment.errors?.["maxlength"]?.requiredLength }}</span
      >
      @if (form.controls.comment.errors?.["minlength"]) {
        <span class="text-red-500 block"
          >{{ "The minimum number of characters is" | translate }}
          {{ form.controls.comment.errors?.["minlength"].requiredLength }}</span
        >
      }
    }
    <button type="submit" class="primary__btn large__screen" translate>
      Add
    </button>

    <button
      type="submit"
      class="small__screen"
      inlineSVG="landing/send.svg"
    ></button>
  </form>
</div>
